import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export default function FirstForm() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [form, setForm] = useState({
    tipoVoo: "",
    horaEmbarque: "",
    horaChegada: "",
    conexao: "nao",
    atraso: "nao",
    assistencia: "nao",
    clima: "nao",
    bagagem: "nenhum",
  });

  const [resultadoKeys, setResultadoKeys] = useState<(keyof typeof t.firstForm)[]>([]);
  const [corResultado, setCorResultado] = useState("");
  const [showNextButton, setShowNextButton] = useState(false);

  const parseTime = (timeStr: string) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    return hours * 60 + minutes;
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const verificarResponsabilidade = () => {
    const result: string[] = [];
    let excludente = false;
    let podeResponsabilizar = false;

    if (form.tipoVoo && form.horaEmbarque && form.horaChegada) {
      const diferenca = parseTime(form.horaEmbarque) - parseTime(form.horaChegada);
      const antecedenciaMinima = form.tipoVoo === "internacional" ? 180 : 60;

      if (diferenca < antecedenciaMinima) {
        result.push("passageiroAntecedencia");
        excludente = true;
      }
    }

    if (form.conexao === "sim") {
      result.push("conexaoExcludente");
      excludente = true;
    }

    if (form.atraso === "sim") {
      result.push("atraso");
      podeResponsabilizar = true;

      if (form.assistencia === "nao") {
        result.push("atrasoSemAssistencia");
      }
    }

    if (form.clima === "sim") {
      result.push("climaExcludente");
      excludente = true;
    }

    if (["extravio", "dano", "furto"].includes(form.bagagem)) {
      if (form.bagagem === "extravio") result.push("bagagemExtravio");
      if (form.bagagem === "dano") result.push("bagagemDano");
      if (form.bagagem === "furto") {
        result.push("bagagemFurto");
        result.push("bagagemFurtoExcludente");
        excludente = true;
      }
      podeResponsabilizar = true;
    }

    if (!excludente && !podeResponsabilizar) {
      result.push("resultadoNaoIndicios");
      setCorResultado("bg-red-200");
      setShowNextButton(false);
    } else if (excludente && !podeResponsabilizar) {
      result.push("excludente");
      setCorResultado("bg-red-200");
      setShowNextButton(true);
    } else if (excludente && podeResponsabilizar) {
      result.push("excludenteEResponsavel");
      setCorResultado("bg-yellow-200");
      setShowNextButton(true);
    } else {
      result.push("podeResponsabilizar");
      setCorResultado("bg-green-200");
      setShowNextButton(true);
    }

    setResultadoKeys(result as (keyof typeof t.firstForm)[]);

  };

  const handleSubmit = () => {
    navigate("/questionario");
  };
  return (
     <div className="p-6 max-w-2xl mx-auto">
      <div className="flex justify-between items-start mb-6">
        <h1 className="text-2xl font-bold">{t.firstForm.tituloform1}</h1>

        <div className="flex gap-2">
          <button
            onClick={() => navigate("/questionario")}
            className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-5 rounded shadow text-base min-w-[315px]"
          >
            {t.firstForm.pularEtapa}
          </button>
        </div>
      </div>
      
      {/* Bloco 1 */}
      <div className="border p-4 mb-4 rounded">
        <h2 className="font-semibold mb-2">{t.firstForm.bloco1}</h2>
        <label className="block mb-2">
          {t.firstForm.tipoVoo}
          <select
            name="tipoVoo"
            value={form.tipoVoo}
            onChange={handleChange}
            className="block w-full mt-1 border rounded p-2"
          >
            <option value="">{t.firstForm.selecione}</option>
            <option value="internacional">{t.firstForm.internacional}</option>
            <option value="nacional">{t.firstForm.nacional}</option>
          </select>
        </label>
        <label className="block mb-2">
          {t.firstForm.horarioEmbarque}
          <input
            type="time"
            name="horaEmbarque"
            value={form.horaEmbarque}
            onChange={handleChange}
            className="block w-full mt-1 border rounded p-2"
          />
        </label>
        <label className="block mb-2">
          {t.firstForm.horarioChegada}
          <input
            type="time"
            name="horaChegada"
            value={form.horaChegada}
            onChange={handleChange}
            className="block w-full mt-1 border rounded p-2"
          />
        </label>
        <label className="block mb-2">{t.firstForm.conexao}</label>
        <div className="flex gap-4 mb-2">
          <label>
            <input
              type="radio"
              name="conexao"
              value="sim"
              checked={form.conexao === "sim"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.sim}
          </label>
          <label>
            <input
              type="radio"
              name="conexao"
              value="nao"
              checked={form.conexao === "nao"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.nao}
          </label>
        </div>
      </div>

      {/* Bloco 2 */}
      <div className="border p-4 mb-4 rounded">
        <h2 className="font-semibold mb-2">{t.firstForm.bloco2}</h2>
        <label className="block mb-2">{t.firstForm.vooAtrasado}</label>
        <div className="flex gap-4 mb-2">
          <label>
            <input
              type="radio"
              name="atraso"
              value="sim"
              checked={form.atraso === "sim"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.sim}
          </label>
          <label>
            <input
              type="radio"
              name="atraso"
              value="nao"
              checked={form.atraso === "nao"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.nao}
          </label>
        </div>
        <label className="block mb-2">{t.firstForm.assistencia}</label>
        <div className="flex gap-4 mb-2">
          <label>
            <input
              type="radio"
              name="assistencia"
              value="sim"
              checked={form.assistencia === "sim"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.sim}
          </label>
          <label>
            <input
              type="radio"
              name="assistencia"
              value="nao"
              checked={form.assistencia === "nao"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.nao}
          </label>
        </div>
      </div>

      {/* Bloco 3 */}
      <div className="border p-4 mb-4 rounded">
        <h2 className="font-semibold mb-2">{t.firstForm.bloco3}</h2>
        <p className="mb-2">
          {t.firstForm.anac}{" "}
          <a
            className="text-blue-500 underline"
            href="https://sas.anac.gov.br/sas/bav/view/frmConsultaVRA"
            target="_blank"
          >
            {t.firstForm.cliqueAqui}
          </a>
        </p>
        <label className="block mb-2">{t.firstForm.clima}</label>
        <div className="flex gap-4">
          <label>
            <input
              type="radio"
              name="clima"
              value="sim"
              checked={form.clima === "sim"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.sim}
          </label>
          <label>
            <input
              type="radio"
              name="clima"
              value="nao"
              checked={form.clima === "nao"}
              onChange={handleChange}
            />{" "}
            {t.firstForm.nao}
          </label>
        </div>
      </div>

      {/* Bloco 4 */}
      <div className="border p-4 mb-4 rounded">
        <h2 className="font-semibold mb-2">{t.firstForm.bloco4}</h2>
        <label className="block mb-2">
          {t.firstForm.bagagem}
          <select
            name="bagagem"
            value={form.bagagem}
            onChange={handleChange}
            className="block w-full mt-1 border rounded p-2"
          >
            <option value="nenhum">{t.firstForm.nenhum}</option>
            <option value="extravio">{t.firstForm.extravio}</option>
            <option value="dano">{t.firstForm.dano}</option>
            <option value="furto">{t.firstForm.furto}</option>
          </select>
        </label>
      </div>

      <div className="flex justify-center mt-7">
        <button
          onClick={verificarResponsabilidade}
          className="bg-blue-600 text-white px-5 py-2.5 rounded text-base font-semibold"
        >
          {t.firstForm.verificar}
        </button>
      </div>

      {resultadoKeys.length > 0 && (
        <pre className={`mt-6 whitespace-pre-wrap p-4 rounded ${corResultado}`}>
          {resultadoKeys.map((key) => t.firstForm[key]).join("\n")}
        </pre>
      )}


      {showNextButton && (
        <div className="flex justify-center mt-7">
          <button
            onClick={handleSubmit}
            className="bg-green-600 text-white px-5 py-2.5 rounded text-base font-semibold"
          >
            {t.firstForm.proximaPagina}
          </button>
        </div>
      )}
    </div>
  );
}
